(() => {
  const ROOT_SELECTOR = '[data-coutureia-eu-legal-guarantee-notice]';
  const OPEN_SELECTOR = '[data-coutureia-eu-guarantee-open]';
  const MODAL_SELECTOR = '[data-coutureia-eu-guarantee-modal]';
  const CLOSE_SELECTOR = '[data-coutureia-eu-guarantee-close]';

  let activeModal = null;
  let activeTrigger = null;
  let activeModalHome = null;

  const getFocusable = (root) => Array.from(root.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter((element) => !element.hidden && element.offsetParent !== null);

  const restoreModalHome = (modal, home) => {
    if (!modal || !home) return;

    if (home.parentNode) {
      home.parentNode.insertBefore(modal, home.nextSibling);
      home.remove();
    } else {
      modal.remove();
    }
  };

  const closeModal = () => {
    if (!activeModal) return;

    const modal = activeModal;
    const trigger = activeTrigger;
    const home = activeModalHome;

    modal.hidden = true;
    document.documentElement.classList.remove('coutureia-eu-guarantee-modal-open');

    activeModal = null;
    activeTrigger = null;
    activeModalHome = null;

    restoreModalHome(modal, home);

    if (trigger && typeof trigger.focus === 'function') {
      trigger.focus({ preventScroll: true });
    }
  };

  const openModal = (modal, trigger) => {
    if (!modal) return;

    if (activeModal && activeModal !== modal) closeModal();
    if (activeModal === modal) return;

    const home = document.createComment('coutureia-eu-guarantee-modal-home');
    modal.parentNode?.insertBefore(home, modal);
    document.body.appendChild(modal);

    activeModal = modal;
    activeTrigger = trigger;
    activeModalHome = home;
    modal.hidden = false;
    document.documentElement.classList.add('coutureia-eu-guarantee-modal-open');

    const closeButton = modal.querySelector(`${CLOSE_SELECTOR}:not([tabindex="-1"])`);
    window.requestAnimationFrame(() => closeButton?.focus({ preventScroll: true }));
  };

  const initRoot = (root) => {
    if (root.dataset.coutureiaEuGuaranteeModalReady === 'true') return;
    root.dataset.coutureiaEuGuaranteeModalReady = 'true';

    const trigger = root.querySelector(OPEN_SELECTOR);
    const modal = root.querySelector(MODAL_SELECTOR);
    if (!trigger || !modal) return;

    trigger.addEventListener('click', () => openModal(modal, trigger));
    modal.querySelectorAll(CLOSE_SELECTOR).forEach((button) => {
      button.addEventListener('click', closeModal);
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  document.addEventListener('keydown', (event) => {
    if (!activeModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusable(activeModal);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', () => {
    if (activeModal) closeModal();
  });
})();
